import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding-bottom: 10px;
  padding-left: 15px;
  padding-right: 15px;
  &::-webkit-scrollbar { width: 0!important }
  overflow: -moz-scrollbars-none!important; }
  -ms-overflow-style: none!important; }

  background-color: #F9F9F9; 
  margin: 15px; 
  border-radius: 10px; 
  padding-top: 15px; 
  padding-bottom: 15px;

  .title-notes {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: -5px;
    margin-bottom: 3px;

    span {
      font-size: 13px;
      color: ${colors.black}!important;
    }
  }

  .close-icon {
    font-size: ${fonts.default}px;
    color: ${colors.black};
    cursor: pointer;
  }

  .action-box {
    display: flex;
    flex: 1;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .btnControls {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    min-width: 50px;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 10px;
    background-color: ${colors.lightGray10};
    cursor: pointer;
    padding: 2px;
    width: 80px;
    padding-right: 0px;
    height: 20px;
    border-radius: 15px;
    text-align: center;
  }

  .off {
      background: transparent!important;
      .count { font-size: 12px; color: ${colors.darkGray06}; }
  }

  .on {
    background: linear-gradient(50.28deg, #67C2E4 2.79%, #0C4BBC 73.37%)!important;
    .count { font-size: 12px; color: #FFF; }
  }

  .disabled {
    background: ${colors.lightGray02} !important;
    .count { font-size: 12px; color: ${colors.darkGray06}; }
  }

  .MuiOutlinedInput-multiline.MuiOutlinedInput-marginDense {
    background-color: #fffbef;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #ece5cf; 
    border-width: 1.5px;
    border-radius: 5px !important;
  }
`;

export const BoxPostNote = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;

  .error-input {
    width: 100%;

    fieldset {
      border: 1pt solid red;
    }
  }
  .normal-input {
    width: 100%;

    fieldset {
      border: 2px solid ${colors.yellow03};
      border-radius: 10px;
    }
  }

  textarea {
    &::-webkit-scrollbar { width: 0!important; height: 0!important; }
    overflow: -moz-scrollbars-none!important;
    &:-ms-overflow-style: none!important;
  }

  .row-controls {
    display: flex;
    width: 100%;
    align-items: flex-end;
    justify-content: space-between;

    .box-messages {
      height: 40px;
    }

    .groupBtns {
      display: flex;
      align-items: flex-start;
      justify-content: center;
    }
  }

  .draftMessage {
    margin-left: 3px;
    font-size: 10px;
    color: green;
  }

  .errorMessage {
    font-size: 10px;
    color: red;
  }
`;

export const NotificationMessage = lib.styled.div`
  display: ${props => (props.disabled ? 'none' : 'flex')};
  flex: 1;
  width: 100%;
  flex-direction: row;
  max-height: 30px;
  min-height: 30px;
  background-color: ${props => (props.success ? colors.green01 : colors.red02)};
  align-items: center;
  justify-content: space-between;

  span {
    color: ${colors.white};
    font-size: 11px;
    padding-left: 15px;
  }
`;
